import { validateEmail, validatePhoneNumber } from 'utils';


export const carrierUsersFields = (carrierUsers) => [
  {
    label:  <span>
    <span>Επωνυμία / Ονοματεπώνυμο</span>
    <span className="color-red"> *</span>
    </span>,
    type: 'text',
    name: 'userLName',
    id: 'userLName',
    size: 'large',
    placeholder: 'Εισάγετε Επωνυμία / Ονοματεπώνυμο',
    span: 8,
    maxLength: 100,
    rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        () => ({
            validator(_, value) {
              const duplicateCount = carrierUsers.filter(u => u.userLName === value).length;

              if (duplicateCount > 1) {
                return Promise.reject('Η Επωνυμία / Ονοματεπώνυμο πρέπει να είναι μοναδικό ανά χρήστη');
              }
            },
          }),
    ],
  },
  {
    label: <span>
    <span>Τηλέφωνο Επικοινωνίας
    </span>
    <span className="color-red"> *</span>
    </span>,
    type: 'text',
    name: 'userPhone',
    id: 'userPhone',
    size: 'large',
    placeholder: 'Εισάγετε Τηλέφωνο Επικοινωνίας',
    maxLength: 10,
    span: 7,
    // containerClassName: "name-width",
    rules: [
          { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
          () => ({
            validator(_, value) {
              const duplicateCount = carrierUsers.filter(u => u.userPhone === value).length;

              if (duplicateCount > 1) {
                return Promise.reject('Το τηλέφωνο πρέπει να είναι μοναδικό ανά χρήστη');
              }
              return validatePhoneNumber(value, false);
            },
          }),
        ],
  },
  {
    label: <span>
    <span>E-mail Επικοινωνίας</span>
    <span className="color-red"> *</span>
    </span>,
    type: 'text',
    name: 'userEmail',
    id: 'userEmail',
    size: 'large',
    placeholder: 'Εισάγετε E-mail Επικοινωνίας',
    span: 8,
    maxLength: 50,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      () => ({
            validator(_, value) {
              const duplicateCount = carrierUsers.filter(u => u.userEmail === value).length;

              if (duplicateCount > 1) {
                return Promise.reject('Το E-mail πρέπει να είναι μοναδικό ανά χρήστη');
              }
              return validateEmail(value);
            },
      }),
    ],
  },
];
